export default __webpack_public_path__ + "images/pages/quiz/categories/mobile_tech-94a5396ca219d8b566099c350a044a1b.svg";